/**
* @name APP u-Planning
* @autor vignesh.somayaji@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: teacherSelfAssessmentController
* # alias: Ctrl
*/

export default class teacherAssessmentController {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, integralEvaluationSrv, $cookies, GlobalConfig, WorkPlanSrv, $mdDialog, $anchorScroll, $location) {
		var selfAss = this

		this.$state = $state
		this.$scope = $scope
		this.$stateParams = $stateParams
		this.ngNotify = ngNotify
		this.$timeout = $timeout
		this.integralEvaluationSrv = integralEvaluationSrv
		this.GlobalConfig = GlobalConfig
		this.$mdDialog = $mdDialog
		this.assignation = []
		this.imageLoader = require('./simplespin.gif')

		this.teachingId = 11
		this.teacherWorkPlanId = 12
		this.commitmentId = 13
		this.openQuestionsId = 14
		this.finalConceptId = 15
		this.TotalProgressPercentage = { 11: 0, 12: 0, 13: 0, 14: 0, 15: 0 }
		this.percentageBarActualTotal = {}
		this.percentageBarTotal = {}
		this.mandorTory = { 11: 0, 12: 0, 13: 0, 15: 0 }

		this.teacherId = this.$stateParams.teacherId
		this.workplanId = this.$stateParams.workplanId
		this.userName = this.$stateParams.name
		this.userId = this.$stateParams.userId
		this.reviewApprove = this.$stateParams.reviewApprove

		this.$scope.UserInfoConstant = UserInfoConstant
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.userinfo = details.user
				this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
				this.main()
			}
		})

		$scope.flags = 'home'
		$scope.teaching = function(id) {
			$scope.flags = id
			// $window.scrollTo(0, angular.element('body').offsetTop); 
			$location.hash('nav_bar_id')
			$anchorScroll()
		}
	}

	main() {
		console.log('Estoy en el controlador de teacherSelfAssessmentController')
		this.activeParam()
	}

	activeParam() {
		var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId, options: 'CHIEF' }

		var THIS = this

		this.integralEvaluationSrv.asignaturesDetails.getAsignaturesDetails(param).$promise.then(function (dataReturn) {
			if (dataReturn.status) {
				THIS.reflection = {}
				THIS.trabajo = {}
				THIS.compromise = {}
				THIS.TotalQuestion = {}
				THIS.questionTitle = {}

				for (var i in dataReturn.data.evaluation) {
					if (typeof THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] === 'undefined') {
						// THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]=0
						// THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]=0
					}

					if (typeof THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues] === 'undefined') {
						// THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues]=
						THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues] = dataReturn.data.evaluation[i].Formulario
					}

					if (dataReturn.data.evaluation[i].id_code_evaluationmenues == THIS.teacherWorkPlanId || 
              dataReturn.data.evaluation[i].id_code_evaluationmenues == THIS.openQuestionsId ||
              dataReturn.data.evaluation[i].id_code_evaluationmenues == THIS.commitmentId) {
						THIS.trabajo[dataReturn.data.evaluation[i].id_code_questions] = dataReturn.data.evaluation[i].text

						if (dataReturn.data.evaluation[i].text != '') {
							// THIS.TotalQuestion[dataReturn.data.evaluation[i].id_code_questions]=dataReturn.data.evaluation[i].text
							// THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]+=1
						}
						// THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]+=1
					}
				}

				for (var i in dataReturn.data.options) {
					if (typeof THIS.questionTitle[dataReturn.data.options[i].id_code_evaluationmenues] === 'undefined') {
						// THIS.questionTitle[dataReturn.data.evaluation[i].id_code_evaluationmenues]=
						THIS.questionTitle[dataReturn.data.options[i].id_code_evaluationmenues] = dataReturn.data.options[i].Formulario
					}

					if (typeof THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] === 'undefined') {
						// THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues]=0
						// THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues]=0
					}

					THIS.trabajo[dataReturn.data.options[i].id_code_questions] = dataReturn.data.options[i].text 
					for (var j in dataReturn.data.options[i].value) {
						if (dataReturn.data.options[i].value[j].values == dataReturn.data.options[i].value[j].id_code_options) {
							THIS.TotalQuestion[dataReturn.data.options[i].id_code_questions] = dataReturn.data.options[i].value[j].id_code_options
							THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder] = dataReturn.data.options[i].value[j].id_code_options
							THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] += 1
						} else {
							THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder] = false
						}
					}
					// THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues]+=1
				}

				THIS.assignation = dataReturn.data
				THIS.docencia = dataReturn.data.evaluation[0].text
				THIS.checkTotalPercentage()
			}
		}, function (data) {
			console.log('sample vignesh', data)
		},
		)
	}

	checkTotalPercentage() {
		// var param={id_teacher:this.teacherId,id_work_plan:this.workplanId,options:'CHIEF'}

		var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId, options: 'CHIEF' }
    
		// var param={id_teacher:this.cookiesUser.teacherId,id_work_plan:this.cookiesUser.workplanId,options:'CHIEF'}
		var THIS = this

		this.integralEvaluationSrv.getTotalPercentageOfEnteredData.getTotal(param).$promise.
			then(function (dataReturn) {
				if (dataReturn.status) {
					console.log('ttttt', dataReturn)
					THIS.TotalProgressPercentage = dataReturn.data
				}
			}, function (data) {
				console.log('sample vignesh', data)
			},
			)
	}

	teacherTextareaOnBlur(id_question, id, event, id_code_asignature) {
		var id_assignations = null

		if (id_question == 1) {
			var id_assignations = null
			var text = this.docencia
		} else {
			var text = this.trabajo[id_question]
		}

		if (id == 'options') {
			var id_code_options = $('input[name=radio-' + id_question + ']:checked').val()
			var param = {
				id_question         : id_question,
				ds_description      : text,
				id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
				id_assignations     : id_assignations,
				id_option           : id_code_options,
			}
		} else {
			var param = {
				id_question         : id_question,
				ds_description      : text,
				id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
				id_assignations     : id_assignations,
			}
		}

		var THIS = this

		if ($.trim(text) != '') {
			this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {
				$('#imag-loader-screen').hide()
				THIS.checkTotalPercentage()
			}, function (data) {
				$('#imag-loader-screen').hide()
				console.log('error', data)
			},
			)
		} else {
			$('#imag-loader-screen').hide()
		}
	}

	optionSave(id_code_options, id_question, id_code_evaluationmenues, event) {
		var param = {
			id_question         : id_question,
			ds_description      : typeof this.trabajo[id_question] === 'undefined' ? null : this.trabajo[id_question],
			id_work_plan_teacher: this.assignation.userDetails.id_workplan_teacher,
			id_option           : id_code_options,
		}

		var THIS = this

		this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {
			$('#imag-loader-screen').hide()
			THIS.checkTotalPercentage()
		}, function (data) {
			console.log('error', data)
			$('#imag-loader-screen').hide()
		},
		)
	}

	endPlanning() {
		var param = { id_teacher: this.teacherId, id_work_plan: this.workplanId, options: 'CHIEF' }
		var THIS = this

		this.integralEvaluationSrv.getTotalPercentageOfEnteredData.getTotal(param).$promise.then(function (dataReturn) {
			// this.integralEvaluationSrv.getMandatoryData.getMandatoryDataFlag(param).$promise.then(function (dataReturn) {
			if (dataReturn.status) {
				var obj = {}, ObjArray = []

				if (dataReturn.data[THIS.teachingId] == 0) {
					ObjArray.push(THIS.questionTitle[THIS.teachingId])
				}

				//  if(dataReturn.data[THIS.teacherWorkPlanId]<100){
				//    ObjArray.push(THIS.questionTitle[THIS.teacherWorkPlanId])
				// }

				// if(dataReturn.data[THIS.commitmentId]<100){
				//    ObjArray.push(THIS.questionTitle[THIS.commitmentId])
				// }

				if (dataReturn.data[THIS.finalConceptId] == 0) {
					ObjArray.push(THIS.questionTitle[THIS.finalConceptId])
				}

				if (ObjArray.length == 0) {
					var obJtArray = []

					for (var i in THIS.assignation.options) {
						if (THIS.assignation.options[i].id_code_evaluationmenues == THIS.teachingId) {
							for (var j in THIS.assignation.options[i].value) {
								if (THIS.compromise[THIS.assignation.options[i].id_code_questions + '-' + THIS.assignation.options[i].value[j].id_code_options] != false) {
									obJtArray.push(THIS.assignation.options[i].value[j])
									obJtArray[0].questionId = THIS.assignation.options[i].id_code_questions
								}
							}
						}
					}

					THIS.endProcessModal(obJtArray[0])
				} else {
					THIS.mandatoryFieldWarningModal(ObjArray)
				}
			}
		}, function (data) {
			console.log('sample vignesh', data)
		})
	} 

	getNotifyEndExecution(idUser, notificationType, details) {
		let data = {
			idUser                      : idUser,
			dsName                      : 'Notificación, evaluación finalizada',
			dsDescription               : 'Profesor: su plan de trabajo ha sido valorado como ' + details.opcionesPreguntas + ' y fueron registrados los siguientes comentarios: ' + this.trabajo[38],
			idNotification_delivery_type: notificationType,
			is_grouped                  : 0,
		}
	}

	mandatoryFieldWarningModal (details) {
		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', function mandatoryFieldWarningModal ($scope, $mdDialog) {
				$scope.data = details
				$scope.close = function () {
					$mdDialog.hide()
				}
			} ],
			template           : require('./model/mandatoryFieldWarningModal.html'),
			clickOutsideToClose: false,
		})
	}

	endProcessModal (details) {
		var THIS = this

		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', 'GlobalConfig', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalSrv', '$state', function mandatoryFieldWarningModal ($scope, $mdDialog, GlobalConfig, WorkPlanSrv, WorkPlanModalSrv, GlobalSrv, $state) {
				// $scope.data = response

				const headData = WorkPlanModalSrv.getVariable()

				const teacherId = THIS.teacherId
				const workplanId = THIS.workplanId
     
				let header = {
					comments  : THIS.trabajo[details.questionId],
					criteriaId: details.values,
					stageId   : 6,
					teacherId : teacherId,
					workplanId: workplanId,
				}

				$scope.teacherName = THIS.userName

				$scope.close = function () {
					$mdDialog.hide()
				}

				$scope.finilize = function() {
					let post = {
						listId    : 2,
						workplanId: header.workplanId,
					}

					WorkPlanSrv.endStages.update(header).$promise.then((dataReturn) => {
						GlobalSrv.sendNotification(THIS.getNotifyEndExecution(THIS.userId, THIS.GlobalConfig.notificationType.inbox, details))
						GlobalSrv.sendNotification(THIS.getNotifyEndExecution(THIS.userId, THIS.GlobalConfig.notificationType.email, details))
						THIS.finalDialog()
						close()
					}).catch((error) => {
						console.log(error)
					})

					$mdDialog.hide()
				}
			} ],
			template           : require('./model/endProcessModal.html'),
			clickOutsideToClose: false,
		})
	}

	finalDialog() {
		var THIS = this

		this.$mdDialog.show({
			controller: [ '$scope', '$mdDialog', '$state', function mandatoryFieldWarningModal ($scope, $mdDialog, $state) {
				// $scope.data = details
				$scope.teacherName = THIS.userName
				$scope.close = function () {
					$mdDialog.hide()

					if (THIS.reviewApprove) {
						$state.go('fullscreen.workPlanReviewExecution')
					} else {
						$state.go('workplan.summaryEvaluation', {
							teacherId : THIS.teacherId,
							workplanId: THIS.workplanId,
							name      : THIS.userName,
						})
					}
				}
			} ],
			template           : require('./model/finalDialogModal.html'),
			clickOutsideToClose: false,
		})
	}

}

teacherAssessmentController.$inject = [ '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'integralEvaluationSrv', '$cookies', 'GlobalConfig', 'WorkPlanSrv', '$mdDialog', '$anchorScroll', '$location' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/integralEvaluation/teacherAssessment/teacherAssessmentController.js